import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import EmptySreen from '../../../components/EmptySreen'
// MUI
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import Box from '@mui/material/Box'
import Tab from '@mui/material/Tab'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
// import FilterIcon from '../../assets/icons/JSX/FilterIcon'
import { useTranslation } from 'react-i18next'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'swiper/css'
import 'swiper/css/pagination'
import { A11y, Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useDebounce } from 'use-debounce'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import FailIcon from '../../../assets/icons/JSX/FailIcon'
import Colors from '../../../assets/styles/Colors'
import DownloadGreyButton from '../../../components/DownloadGreyButton'
import FilterButton from '../../../components/FilterButton'
import HorizontalPendingPolicyCard from '../../../components/HorizontalPendingPolicyCard'
import HorizontalPolicyCard from '../../../components/HorizontalPolicyCard'
import Loader from '../../../components/Loader'
import PayButton from '../../../components/PayButton'
import PayButtonGrey from '../../../components/PayButtonGrey'
import PoliciesCheckbox from '../../../components/PoliciesCheckbox'
import TrashButton from '../../../components/TrashButton'
import TrashGreyButton from '../../../components/TrashGreyButton'
import DeleteModal from '../../../components/modals/DeleteModal'
import PendingPayModal from '../../../components/modals/PendingPayModal'
import Dropdown from '../../../components/v2/Dropdown'
import Input from '../../../components/v2/Input'
import Button from '../../../components/v2/buttons/Button'
import { ExportPoliciesFilter, PolicyFilter, PromoCode } from '../../../domain/types'
import { RootState, useAppSelector } from '../../../store'
import { AuthState } from '../../../store/authSlice'
import PendingPayments from '../payment/PendingPayments'
import PromoCodeModal from '../../../components/modals/PromoCodeModal'
import PromoCodeThreeIcon from '../../../assets/icons/JSX/PromoCodeThreeIcon'
import dayjs from 'dayjs'
import axios from 'axios'
import { saveAs } from 'file-saver'
import { AppState } from '../../../store/appSlice'
import ExportButton from '../../../components/ExportButton'
import ExportPoliciesModal from '../../../components/modals/ExportPoliciesModal'
//
//
const MyPolicies = () => {
  // for filter
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const [showFilters, setShowFilters] = useState<boolean>(false)
  //
  const [pageNumber, setPageNumber] = useState<number>(1)
  //
  const [filter, setFilter] = useState<PolicyFilter>({})
  //
  const [insuredDebounceName] = useDebounce(filter?.insured, 1000)
  //
  const [selectedPromoCode, setSelectedPromoCode] = useState<Partial<PromoCode> | null>(null)
  //
  const auth = useSelector<RootState, AuthState>((state) => state.auth)
  //
  const { data: promoCodes } = api.useGetUserPromoCodesQuery(
    { userId: auth.user?.id as number },
    { skip: !auth.user?.id },
  )
  //
  //
  const setFielterField = (fieldName: keyof PolicyFilter, fieldValue: any) => {
    setFilter({
      ...filter,
      [fieldName]: fieldValue,
    })
  }
  //
  // For mui tab
  const [activeTab, setActiveTab] = React.useState('1')
  //
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue)
    setIdsToHandle([])
  }
  //
  const navigate = useNavigate()
  //
  // Set active mui tab to the same one that was active before, when user presses "back" button
  const location = useLocation()

  useEffect(() => {
    const tabValue = new URLSearchParams(location.search).get('tab') ?? '1'
    setActiveTab(tabValue)
  }, [location.search])

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('tab', activeTab)
    const newPath = `${location.pathname}?${searchParams.toString()}`
    window.history.replaceState(null, '', newPath)
  }, [activeTab, location.pathname, location.search])
  //
  //
  const { t } = useTranslation()
  //
  // Function to get insurer name based on policy type
  const getInsurerName = (item: any): string => {
    if (item?.targetType === 'InternationalTplPolicy') {
      const policyOptions = item?.options || item?.policyOptions
      const insurerInformation = policyOptions?.insurerInformation
      const individualInfo = insurerInformation?.individualPersonalInformation
      const legalEntityInfo = insurerInformation?.legalEntityPersonalInformation

      const firstName =
        individualInfo?.firstNameEn ||
        legalEntityInfo?.representativeInformation?.firstNameEn ||
        individualInfo?.firstNameGe ||
        item?.translations?.[lang]?.firstName ||
        item?.translations?.en?.firstName

      const lastName =
        individualInfo?.lastNameEn ||
        legalEntityInfo?.representativeInformation?.lastNameEn ||
        individualInfo?.lastNameGe ||
        item?.translations?.[lang]?.lastName ||
        item?.translations?.en?.lastName

      return `${firstName || ''} ${lastName || ''}`.trim()
    }

    // Default logic for other policy types
    return `${item?.translations?.en?.firstName || ''} ${item?.translations?.en?.lastName || ''}`.trim()
  }
  //
  const {
    data: userActivePolicies,
    isFetching: isActivePoliciesLoading,
    refetch: isActivePolicyRefetch,
  } = api.useGetUserActivePoliciesQuery({
    page: activeTab === '1' ? pageNumber : undefined,
    category: activeTab === '1' ? filter?.category : undefined,
    companyId: activeTab === '1' ? filter?.companyId : undefined,
    insured: activeTab === '1' ? insuredDebounceName : undefined,
  })
  //
  const {
    data: userPendingPolicies,
    isFetching: isPendingLoading,
    refetch: isPendingPolicyRefetch,
  } = api.useGetUserPendingPoliciesQuery({
    page: activeTab === '2' ? pageNumber : undefined,
    category: activeTab === '2' ? filter?.category : undefined,
    companyId: activeTab === '2' ? filter?.companyId : undefined,
    insured: activeTab === '2' ? insuredDebounceName : undefined,
  })
  //
  const { data: userClosedPolicies, isFetching: isClosedLoading } = api.useGetUserClosedPoliciesQuery({
    page: activeTab === '3' ? pageNumber : undefined,
    category: activeTab === '3' ? filter?.category : undefined,
    companyId: activeTab === '3' ? filter?.companyId : undefined,
    insured: activeTab === '3' ? insuredDebounceName : undefined,
  })
  //
  //
  const { data: paymentMethods, isLoading: isPaymentMethodsLoading } = api.useGetTplPaymentMethodsQuery(undefined)
  //
  const { data: companies, isFetching: isCompaniesLoading } = api.useGetFilterCompaniesQuery(undefined)
  // pagination onClick
  const handlePageClick = (event: any) => {
    setPageNumber(event.selected + 1)
  }
  //
  //
  const [idsToHandle, setIdsToHandle] = useState<number[]>([])

  const handleCheckboxChange = (policyId: number) => {
    setIdsToHandle((prevIds: any) => {
      if (prevIds.includes(policyId)) {
        return prevIds.filter((id: any) => id !== policyId)
      } else {
        return [...prevIds, policyId]
      }
    })
  }
  //
  //
  const [deletePendingPolicy, { isLoading: isdeletePendingPolicyLoading }] = api.useDeleteUserPendingPolicyMutation()

  //
  //
  const [exportUserPolicies, { isLoading: isExportPoliciesLoading }] = api.useExportUserPoliciesMutation()
  //
  //

  const handleSingleDeleteButtonClick = (event: Event, policyId: number) => {
    event?.stopPropagation()
    isPendingPolicyRefetch()
    setIdsToHandle([policyId])
    setOpenDeleteModal(true)
  }
  //
  const deletePolicies = async () => {
    try {
      for (const id of idsToHandle) {
        await deletePendingPolicy(id).unwrap()
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (deletePolicies)')
      }
    }
    _onCloseDeleteModal()
    setIdsToHandle([])
    isPendingPolicyRefetch()
  }
  //
  //
  const exportPolicies = async (filterParams: ExportPoliciesFilter) => {
    try {
      if (!filterParams.registerDateFrom || !filterParams.registerDateTo) {
        toast.error(`${t('exportModal.notValidData')}`)
        return
      }

      const exportedData = await exportUserPolicies(filterParams).unwrap()

      if (exportedData?.url && exportedData.url.endsWith('.xlsx')) {
        window.open(exportedData.url, '_blank')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (exportPolicies)')
      }
    }
    _onCloseExportPoliciesModal()
    setIdsToHandle([])
  }
  //
  //
  const downloadPdf = (event: Event, url?: string) => {
    event?.stopPropagation()
    if (url) {
      const fileName = url?.split('frani.com/')?.[1] || 'file name not found'
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/pdf',
        },
      })
        .then((response) => {
          const pdfBlob = new Blob([response.data], { type: 'application/pdf' })
          saveAs(pdfBlob, fileName)
        })
        .catch((error) => {
          toast.error('ფაილის ჩამოტვირთვისას მოხდა შეცდომა:', error)
        })
    }
  }
  //
  //
  const [createOrder, { data: createPendingNewOrder, isLoading: isCreatePendingNewOrderLoading }] =
    api.useCreateUserPendingNewOrderMutation()

  const paySelectedPendingPolicies = async () => {
    try {
      const response = await createOrder({
        policyIds: idsToHandle,
        targetType: userPendingPolicies?.data?.find((x) => idsToHandle.includes(x.id))?.targetType,
      }).unwrap()
      if ('orderItems' in response) {
        setOpenDialogModal(true)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (203)')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message
        toast.error(errorMessage)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySelectedPendingPolicies) (211)')
      }
    }
  }

  const paySinglePendingPolicies = async (event: Event, policyId: number) => {
    event.stopPropagation()
    setIdsToHandle([policyId])
    try {
      const response = await createOrder({
        policyIds: [policyId],
        targetType: userPendingPolicies?.data?.find((x) => x.id === policyId)?.targetType,
      }).unwrap()
      if ('orderItems' in response) {
        setOpenDialogModal(true)
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySinglePendingPolicies) (226)')
      }
    } catch (error: any) {
      if (error?.data?.errors?.constructor === Array) {
        const firstError = error.data.errors[0]
        const errorMessage = firstError.message

        if (errorMessage === 'RENEW_OFFER_NOT_FOUND') {
          toast.info(`${t('offersNotFoundCurrentConditions')}`)
        } else {
          toast.error(errorMessage)
        }
      } else {
        toast.error('Მოხდა შეცდომა. Გთხოვთ სცადოთ მოგვიანებით... (paySinglePendingPolicies) (234)')
      }
    }
  }

  //
  const normalizePolicySlug = (slug?: string) => (slug === 'international-tpl' ? 'tpl' : slug)

  const getOrderItemAmount = (item: any, normalizedSlug?: string) => {
    if (normalizedSlug === 'pet' || normalizedSlug === 'tpl') {
      return item?.totalPrice || createPendingNewOrder?.order?.totalPrice
    }
    if (normalizedSlug === 'travel-outside-georgia') {
      return item?.eachPrice
    }

    return item?.price
  }

  const orderModalInfo = createPendingNewOrder?.orderItems.map((item) => {
    const normalizedSlug = normalizePolicySlug(item?.slug)
    return {
      companyName: item?.company?.[lang]?.title,
      amount: getOrderItemAmount(item, normalizedSlug),
      insuranceType: item?.category?.[lang]?.title,
      paymentScheduleType: paymentMethods?.find((x) => x.id === item?.paymentScheduleTypeId)?.slug,
      eachPrice: item?.eachPrice,
      monthlyPrice: item?.monthlyPrice,
      slug: item?.slug,
      totalPrice: item?.totalPrice,
      currency: item?.currency,
    }
  })

  //
  const orderId = createPendingNewOrder?.order?.id
  const totalPrice = createPendingNewOrder?.order?.totalPrice
  const category = createPendingNewOrder?.orderItems?.map((x) => x.slug)
  const discountUsed = createPendingNewOrder?.order?.discounted
  const validPromoCode = createPendingNewOrder?.order?.validPromoCode
  const paymentScheduleType = createPendingNewOrder?.orderItems?.map((x) => x.paymentScheduleTypeSlug)
  const currentPaymentAmount = createPendingNewOrder?.order?.currentPaymentAmount

  const orderInfo = {
    orderId: orderId,
    totalPrice: totalPrice,
    category: category,
    discountUsed: discountUsed,
    paymentScheduleType: paymentScheduleType,
    currentPaymentAmount: currentPaymentAmount,
    validPromoCode: validPromoCode,
  }
  //
  //
  const [openPendingPayments, setOpenPendingPayments] = useState<boolean>(false)
  //
  // active page count
  const activePageCount = userActivePolicies && Math.ceil(userActivePolicies?.meta?.total / 20)
  //
  // close page count
  const closePageCount = userClosedPolicies && Math.ceil(userClosedPolicies?.meta?.total / 20)
  //
  // pending page count
  const pendingPageCount = userPendingPolicies && Math.ceil(userPendingPolicies?.meta?.total / 20)
  //
  //
  const [openDialogModal, setOpenDialogModal] = useState<boolean>(false)
  //
  //close dialog modal
  const _onCloseDialogMOdal = () => {
    isActivePolicyRefetch()
    setIdsToHandle([])
    setOpenDialogModal(false)
  }
  //
  //
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false)
  //
  //close delete dialog modal
  const _onCloseDeleteModal = () => {
    isActivePolicyRefetch()
    setIdsToHandle([])
    setOpenDeleteModal(false)
  }
  //
  //
  const [openExportPoliciesModal, setOpenExportPoliciesModal] = useState<boolean>(false)
  //
  //close export policies modal
  const _onCloseExportPoliciesModal = () => {
    setOpenExportPoliciesModal(false)
  }
  //
  //
  const MainLoader =
    isActivePoliciesLoading ||
    isClosedLoading ||
    isPendingLoading ||
    isCompaniesLoading ||
    isdeletePendingPolicyLoading ||
    isCreatePendingNewOrderLoading ||
    isPaymentMethodsLoading ||
    isExportPoliciesLoading
  //
  //
  // handle different oder id policies for pay button
  const filteredPolicies = userPendingPolicies?.data.filter((policy) => idsToHandle.includes(policy.id))
  //
  const orderIdsArr: (number | undefined)[] = [
    // @ts-ignore
    ...(new Set(filteredPolicies?.map((policy) => policy?.orderItems?.[0]?.orderId)) || []),
  ]

  //
  const hasUndefined = filteredPolicies && filteredPolicies?.length > 1 ? orderIdsArr?.includes(undefined) : false

  const differentOrderIds = orderIdsArr?.length > 1 || hasUndefined

  useEffect(() => {
    if (differentOrderIds) {
      //
      toast.warning(
        lang === 'ge'
          ? 'გთხოვთ გაითვალისწინოთ, რომ ერთიანი გადახდა შეზღუდულია სხვადასხვა ფასდაკლების ტიპიდან გამომდინარე'
          : 'Please be aware that the single payment is restricted due to multiple discounts',
      )
      //
    }
  }, [differentOrderIds, lang])
  //
  //
  return MainLoader ? (
    <Loader />
  ) : openPendingPayments ? (
    <PendingPayments orderInfo={orderInfo} />
  ) : (
    <Wrapper>
      {promoCodes && promoCodes.length >= 1 ? (
        <PromoCodeBlock>
          <Swiper
            slidesPerView="auto"
            scrollbar={{ draggable: true }}
            spaceBetween={10}
            modules={[Autoplay, A11y, Pagination]}
            pagination={{
              clickable: true,
              renderBullet: function (index: number, className: string) {
                return '<span class="' + className + '"> </span>'
              },
            }}
            loop={true}
            navigation={{
              enabled: true,
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            autoplay={{
              delay: 4000,
              pauseOnMouseEnter: true,
              disableOnInteraction: true,
            }}
          >
            {promoCodes?.map((item: any, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <PromoCodes onClick={() => setSelectedPromoCode(item)}>
                    <PromoCodeThreeIconStyle />
                    <PromoCodeTexts>
                      {item.type === 'amount' && (
                        <LargeText
                          dangerouslySetInnerHTML={{
                            __html: t('getAmountDiscount', { amount: item?.applyingDiscount?.amount }),
                          }}
                        />
                      )}

                      {item.type === 'percentage' && (
                        <LargeText
                          dangerouslySetInnerHTML={{
                            __html: t('getPercentageDiscount', {
                              percent: item?.applyingDiscount?.percentageDiscount?.percentage,
                            }),
                          }}
                        />
                      )}

                      {item.type === 'days' && (
                        <LargeText
                          dangerouslySetInnerHTML={{
                            __html: t('getDaystDiscount', { days: item?.applyingDiscount?.days }),
                          }}
                        />
                      )}

                      <SmallText>
                        {t('promoCodeText')}:<span>{item.code}</span>
                      </SmallText>
                    </PromoCodeTexts>
                  </PromoCodes>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </PromoCodeBlock>
      ) : null}

      <PromoCodeModal
        discountAmount={selectedPromoCode?.applyingDiscount?.amount}
        discountPercentage={selectedPromoCode?.applyingDiscount?.percentageDiscount?.percentage}
        discountDays={selectedPromoCode?.applyingDiscount?.days}
        discountType={selectedPromoCode?.type}
        endDate={dayjs(selectedPromoCode?.endDate).format('DD.MM.YYYY')}
        imageUrl={selectedPromoCode?.imageUrl}
        code={selectedPromoCode?.code}
        isOpen={!!selectedPromoCode}
        onClose={() => setSelectedPromoCode(null)}
      />

      <MuiBox>
        <TabContext value={activeTab}>
          <BoxStyle>
            <MuiTabList onChange={handleChange} aria-label="lab API tabs example">
              <MuiTab label={t('activePolicies')} value="1" />
              <MuiTab label={t('pendingPolicies')} value="2" />
              <MuiTab label={t('inActivePolicies')} value="3" />
            </MuiTabList>
            <MainFilterBtn>
              {activeTab === '1' ? (
                <ExportButton
                  onClick={() => setOpenExportPoliciesModal(true)}
                  style={{
                    marginRight: '10px',
                  }}
                  text={t('exportModal.button')}
                />
              ) : null}
              {activeTab === '1' && userActivePolicies?.data?.length !== 0 ? (
                <FilterButton onClick={() => setShowFilters(!showFilters)} text={t('filter')} />
              ) : null}
              {activeTab === '2' && userPendingPolicies?.data?.length !== 0 && idsToHandle.length === 0 ? (
                <FilterButton onClick={() => setShowFilters(!showFilters)} text={t('filter')} />
              ) : null}
              {activeTab === '2' && userPendingPolicies?.data?.length !== 0 && idsToHandle.length !== 0 ? (
                <>
                  {!differentOrderIds && (
                    <PayButton
                      onClick={() => {
                        paySelectedPendingPolicies()
                      }}
                      text="Pay"
                      style={{ width: '144px' }}
                    />
                  )}
                  <TrashButton onClick={() => setOpenDeleteModal(true)} />
                </>
              ) : null}

              {activeTab === '3' && userClosedPolicies?.data?.length !== 0 ? (
                <FilterButton onClick={() => setShowFilters(!showFilters)} text={t('filter')} />
              ) : null}
            </MainFilterBtn>
          </BoxStyle>

          <MobileFilterBtn>
            {activeTab === '1' && userActivePolicies?.data?.length !== 0 ? (
              <FilterButton
                onClick={() => setShowFilters(!showFilters)}
                text={t('filter')}
                style={{
                  width: '100%',
                }}
              />
            ) : null}

            {activeTab === '2' && userPendingPolicies?.data?.length !== 0 && idsToHandle.length === 0 ? (
              <FilterButton
                onClick={() => setShowFilters(!showFilters)}
                text={t('filter')}
                style={{
                  width: '100%',
                }}
              />
            ) : null}
            {activeTab === '2' && userPendingPolicies?.data?.length !== 0 && idsToHandle.length !== 0 ? (
              <>
                <PayButton
                  onClick={() => {
                    paySelectedPendingPolicies()
                  }}
                  text="Pay"
                  style={{ width: '100%' }}
                />
                <TrashButton onClick={() => setOpenDeleteModal(true)} />
              </>
            ) : null}

            {activeTab === '3' && userClosedPolicies?.data?.length !== 0 ? (
              <FilterButton
                onClick={() => setShowFilters(!showFilters)}
                text={t('filter')}
                style={{
                  width: '100%',
                }}
              />
            ) : null}
          </MobileFilterBtn>

          <DropdownWrapper
            style={{
              display: showFilters === true ? 'grid' : 'none',
            }}
          >
            <Dropdown
              title={`${t('company')}`}
              isSearchable={window.innerWidth <= 1200 ? false : true}
              value={filter.companyId || ''}
              options={
                companies
                  ? [
                      ...companies.map((company) => ({
                        value: company.id,
                        label: company.title,
                      })),
                    ]
                  : []
              }
              onChange={(obj) => setFielterField('companyId', obj.value)}
            />

            <Input
              id="insured-field"
              name="insured-field"
              label={`${t('insuredFullName')}`}
              type="text"
              placeholder=""
              value={filter.insured || ''}
              onChange={(value) => setFielterField('insured', value)}
              width={'fullWidth'}
            />
          </DropdownWrapper>

          <SearchedResultDiv
            style={{
              display: showFilters === true ? 'flex' : 'none',
            }}
          >
            <div>
              {t('weFoundIt')}{' '}
              {activeTab === '1'
                ? userActivePolicies?.data?.length
                : activeTab === '2'
                ? userPendingPolicies?.data?.length
                : activeTab === '3'
                ? userClosedPolicies?.data?.length
                : 0}{' '}
              {t('result')}
            </div>
            <button onClick={() => [setFilter({})]}>{t('cleanUp')}</button>
          </SearchedResultDiv>

          {
            <ExportPoliciesModal
              onClose={_onCloseExportPoliciesModal}
              isOpen={openExportPoliciesModal}
              onClick={(data) =>
                exportPolicies({
                  registerDateFrom: data.registerDateFrom,
                  registerDateTo: data.registerDateTo,
                  policyDateFrom: data.policyDateFrom,
                  policyDateTo: data.policyDateTo,
                })
              }
            >
              {t('exportPolicies')}
            </ExportPoliciesModal>
          }

          <MuiTabPanel value="1">
            {userActivePolicies?.data?.length === 0 ? (
              <EmptySreen
                bigText={t('youDontHaveActovePolicies')}
                smallDescription={t('noActivePolicyDescription')}
                buttonText={t('priceCalculation')}
                buttonUrl="/category"
              />
            ) : (
              <>
                {userActivePolicies &&
                  userActivePolicies?.data?.map((item, index) => {
                    return (
                      <HorizontalPolicyCard
                        // onClick={() => navigate(`/travel-policy-detail/${item.id}`)}
                        onClick={() => {
                          if (item?.targetType === 'TravelPolicy') {
                            // navigate travel detail page
                            navigate(`/travel-policy-detail/${item.id}`)
                            //
                          } else if (item?.targetType === 'TplPolicy') {
                            // navigate tpl detail page
                            navigate(`/tpl-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'InternationalTplPolicy') {
                            // navigate international tpl detail page
                            navigate(`/international-tpl-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'WelcomerPolicy') {
                            // navigate welcomer detail page
                            navigate(`/welcomer-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'PetPolicy') {
                            // navigate pet detail page
                            navigate(`/pet-policy-detail/${item?.id}`)
                          }
                        }}
                        key={index}
                        dateFrom={item?.startDate}
                        dateTo={item?.endDate}
                        companyName={item?.package?.product?.company.translations?.[lang]?.title}
                        type={item?.targetType}
                        insurerName={getInsurerName(item)}
                        policyNumber={item?.policyNumber}
                        policyStatus={item?.status}
                        policyId={item.id}
                        iconChildren={
                          item?.targetType === 'InternationalTplPolicy' ? null : (
                            <span>
                              <DownloadGreyButton onClick={(event) => downloadPdf(event, item.policyPdfUrl)} />
                            </span>
                          )
                        }
                      />
                    )
                  })}

                {userActivePolicies && userActivePolicies?.meta?.total <= 20 ? null : (
                  <CustomPaginationWrapper>
                    <ReactPaginate
                      breakLabel={'...'}
                      forcePage={(userActivePolicies?.meta?.current_page as number) - 1}
                      nextLabel={<RightIcon />}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={1}
                      pageCount={activePageCount || 0}
                      previousLabel={<LeftIcon />}
                      // renderOnZeroPageCount={null}
                    />
                  </CustomPaginationWrapper>
                )}
              </>
            )}
          </MuiTabPanel>
          {/*  */}
          <MuiTabPanel value="2">
            {userPendingPolicies?.data?.length === 0 ? (
              <EmptySreen
                bigText={t('noPendingPolicyText')}
                smallDescription={t('noPendingPolicyDescription')}
                buttonText={t('priceCalculation')}
                buttonUrl="/category"
              />
            ) : (
              <>
                {userPendingPolicies &&
                  userPendingPolicies?.data?.map((item, index) => {
                    return (
                      <>
                        <HorizontalPendingPolicyCard
                          checkbox={
                            <PoliciesCheckbox
                              id="pending-policies-checkbox"
                              label={''}
                              onChange={() => handleCheckboxChange(item.id)}
                              onClick={(event: { stopPropagation: () => any }) => event.stopPropagation()}
                              defaultChecked={idsToHandle.includes(item.id) ? true : false}
                            />
                          }
                          onClick={
                            !idsToHandle.includes(item.id)
                              ? () => {
                                  if (item?.targetType === 'TravelPolicy') {
                                    // navigate travel detail page
                                    navigate(`/travel-policy-detail/${item.id}`)
                                    //
                                  } else if (item?.targetType === 'TplPolicy') {
                                    // navigate tpl detail page
                                    navigate(`/tpl-policy-detail/${item.id}`)
                                  } else if (item?.targetType === 'InternationalTplPolicy') {
                                    // navigate international tpl detail page
                                    navigate(`/international-tpl-policy-detail/${item.id}`)
                                  } else if (item?.targetType === 'WelcomerPolicy') {
                                    // naviagate welcomer detail page
                                    navigate(`/welcomer-policy-detail/${item.id}`)
                                  } else if (item?.targetType === 'PetPolicy') {
                                    // navigate pet detail page
                                    navigate(`/pet-policy-detail/${item?.id}`)
                                  }
                                }
                              : undefined
                          }
                          style={idsToHandle.includes(item.id) ? { border: '1px solid black' } : {}}
                          key={index}
                          dateFrom={item?.startDate}
                          dateTo={item?.endDate}
                          companyName={item?.package?.product?.company?.translations?.[lang]?.title}
                          type={item?.targetType.replace('Policy', '')}
                          insurerName={getInsurerName(item)}
                          policyNumber={item?.policyNumber}
                          policyStatus={item?.status}
                          policyId={item.id}
                          iconChildren={
                            <>
                              <PayButtonGrey
                                onClick={(event) => {
                                  paySinglePendingPolicies(event, item?.id)
                                }}
                              />
                              <TrashGreyButton
                                onClick={(event) => {
                                  handleSingleDeleteButtonClick(event, item?.id)
                                }}
                              />
                            </>
                          }
                        />
                      </>
                    )
                  })}

                {
                  <PendingPayModal
                    onClick={() => setOpenPendingPayments(true)}
                    onClose={_onCloseDialogMOdal}
                    isOpen={openDialogModal}
                    orderModalInfo={orderModalInfo}
                    orderInfo={orderInfo}
                  >
                    Payment details
                  </PendingPayModal>
                }
                {
                  <DeleteModal onClose={_onCloseDeleteModal} isOpen={openDeleteModal}>
                    <ModalItems>
                      <FailIcon />
                      <ModalText>{t('areYouSureYouWantToDelete')}</ModalText>
                      <Button onClick={deletePolicies} text={t('yesDelete')} fullWidth />
                      <Button
                        onClick={_onCloseDeleteModal}
                        text={t('cancel')}
                        buttonType="transparent"
                        style={{ border: 'none', marginTop: '10px' }}
                        fullWidth
                      />
                    </ModalItems>
                  </DeleteModal>
                }

                {userPendingPolicies && userPendingPolicies?.meta?.total <= 20 ? null : (
                  <CustomPaginationWrapper>
                    <ReactPaginate
                      breakLabel={'...'}
                      forcePage={(userPendingPolicies?.meta?.current_page as number) - 1}
                      nextLabel={<RightIcon />}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={1}
                      pageCount={pendingPageCount || 0}
                      previousLabel={<LeftIcon />}
                      // renderOnZeroPageCount={null}
                    />
                  </CustomPaginationWrapper>
                )}
              </>
            )}
          </MuiTabPanel>
          {/*  */}
          <MuiTabPanel value="3">
            {userClosedPolicies?.data?.length === 0 ? (
              <EmptySreen
                bigText={t('noActivePolicyText')}
                smallDescription={t('noActivePolicyDescription')}
                buttonText={t('priceCalculation')}
                buttonUrl="/category"
              />
            ) : (
              <>
                {userClosedPolicies &&
                  userClosedPolicies?.data?.map((item, index) => {
                    return (
                      <HorizontalPolicyCard
                        onClick={() => {
                          if (item?.targetType === 'TravelPolicy') {
                            // navigate travel detail page
                            navigate(`/travel-policy-detail/${item.id}`)
                            //
                          } else if (item?.targetType === 'TplPolicy') {
                            // navigate tpl detail page
                            navigate(`/tpl-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'InternationalTplPolicy') {
                            // navigate international tpl detail page
                            navigate(`/international-tpl-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'WelcomerPolicy') {
                            // naviagate welcomer detail page
                            navigate(`/welcomer-policy-detail/${item.id}`)
                          } else if (item?.targetType === 'PetPolicy') {
                            // navigate pet detail page
                            navigate(`/pet-policy-detail/${item?.id}`)
                          }
                        }}
                        key={index}
                        dateFrom={item?.startDate}
                        dateTo={item?.endDate}
                        companyName={item?.package?.product?.company.translations?.[lang]?.title}
                        type={item?.targetType}
                        insurerName={getInsurerName(item)}
                        policyNumber={item?.policyNumber}
                        policyStatus={item?.status}
                        policyId={item.id}
                        iconChildren={
                          <span>
                            <DownloadGreyButton onClick={(event) => downloadPdf?.(event, item.policyPdfUrl)} />
                          </span>
                        }
                      />
                    )
                  })}

                {userClosedPolicies && userClosedPolicies?.meta?.total <= 20 ? null : (
                  <CustomPaginationWrapper>
                    <ReactPaginate
                      breakLabel={'...'}
                      forcePage={(userClosedPolicies?.meta?.current_page as number) - 1}
                      nextLabel={<RightIcon />}
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={1}
                      pageCount={closePageCount || 0}
                      previousLabel={<LeftIcon />}
                      // renderOnZeroPageCount={null}
                    />
                  </CustomPaginationWrapper>
                )}
              </>
            )}
          </MuiTabPanel>
        </TabContext>
      </MuiBox>
    </Wrapper>
  )
}

// styles
const PromoCodeThreeIconStyle = styled(PromoCodeThreeIcon)`
  height: 100%;
  position: absolute;
  top: -10px;
  left: 50%;
  transform: translateX(-50%) scale(1.15);
  user-select: none;
  pointer-events: none;
`
const SmallText = styled.div`
  font-size: 13px;
  color: ${Colors.white};
  margin-top: 5px;

  span {
    margin-left: 16px;
    background-color: ${Colors.white};
    color: ${Colors.primaryBlack};
    padding: 5px 8px;
    border-radius: 2px;
    font-size: 13px;
    font-weight: bold;
  }

  ${Responsive.mobile} {
    margin-top: 15px;
  }
`
const LargeText = styled.div`
  font-size: 20px;
  line-height: 20px;
  color: ${Colors.white};
  font-weight: bold;

  span {
    color: ${Colors.primaryRed};
  }
`
const PromoCodeTexts = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
  height: 100%;

  ${Responsive.mobile} {
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
  }
`
const PromoCodes = styled.div`
  height: 80px;
  width: 100%;
  border-radius: 8px;
  background-color: ${Colors.secondaryBlack};
  overflow: hidden;
  cursor: pointer;

  ${Responsive.mobile} {
    height: 95px;
  }
`
const PromoCodeBlock = styled.div`
  margin-block: 13px 16px;
  border-radius: 8px;
  position: relative;
  padding-bottom: 18px;

  .swiper {
    position: unset;
  }

  .swiper-horizontal {
    border-radius: 8px;
  }

  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
    bottom: 0;
  }

  .swiper-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-pagination-bullet {
    display: block;
    height: 8px;
    width: 8px;
    background-color: ${Colors.Black};
  }

  .swiper-pagination-bullet.swiper-pagination-bullet-active {
    background-color: ${Colors.primaryRed};
    height: 12px;
    width: 12px;
  }
`
const MainFilterBtn = styled.div`
  display: flex;
  margin-left: auto;
  ${Responsive.mobile} {
    display: none;
  }
`
const MobileFilterBtn = styled.div`
  display: none;
  ${Responsive.mobile} {
    display: flex;
    margin-block: 24px;
    width: 100%;
  }
`
const SearchedResultDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    font-size: 14px;
    color: ${Colors.nevadaGrey};
  }

  button {
    font-size: 14px;
    outline: none;
    border: 0px;
    padding: 3px;
    margin: 0px;
    background-color: transparent;
    border-bottom: 1px solid ${Colors.primaryBlack};
    color: ${Colors.primaryBlack};
    -webkit-text-fill-color: rgba(0, 0, 0, 1);
    /* -webkit-opacity: 1; */

    &:active {
      opacity: 0.8;
    }
  }
`
const CustomPaginationWrapper = styled.div`
  margin-block: 20px;
  display: grid;
  place-items: center;
  ul {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
    margin-bottom: 0px;
    li {
      user-select: none;
      font-size: 14px;
      line-height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 6px;
      background-color: transparent;
      /* color: var(--text-color); */
      height: 30px;
      width: 30px;
      cursor: pointer;
      margin-inline: 1px;

      a {
        width: 100%;
        text-align: center;
        display: grid;
        place-items: center;
      }

      &.disabled {
        opacity: 0.6;
      }

      &.break {
        a {
          height: 100%;
          margin-top: -8px;
          color: ${Colors.primaryRed};
        }
      }
      &.selected {
        background-color: ${Colors.primaryRed};
        color: ${Colors.white};
      }
    }
  }

  ${Responsive.mobile} {
    ul {
      li {
        margin: 0 5px;
        font-size: 14px;
        height: 24px;
        width: 24px;
      }
    }
  }
`
const RightIcon = styled(DoubleRightIcon)`
  color: ${Colors.primaryRed};
  height: 15px;
`
const LeftIcon = styled(DoubleRightIcon)`
  transform: rotate(180deg);
  color: ${Colors.primaryRed};
  height: 15px;
`
const MuiTabList = styled(TabList)`
  /* mui button */
  .MuiButtonBase-root {
    padding: 0px;
    margin-right: 50px;
    font-size: 18px;
    text-transform: none;

    &:last-child {
      margin-right: 0px;
    }
  }
  /* MUI tab bottom line */
  .MuiTabs-indicator {
    background-color: ${Colors.primaryBlack} !important;
  }
  /* MUi tab click effect */
  .MuiTouchRipple-root {
    display: none !important;
  }
  ${Responsive.mobile} {
    /*  */
    .MuiTabs-flexContainer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    /*  */
    .MuiButtonBase-root {
      margin-right: 0px;
      font-size: 15px;
    }
    /*  */
    /* mui button */
    button {
      margin-right: auto;
      font-size: 13px;
    }
  }
`
const MuiTab = styled(Tab)`
  color: ${Colors.primaryBlack} !important;
`
const MuiTabPanel = styled(TabPanel)`
  padding: 0px !important;
  margin-top: 45px;
  ${Responsive.mobile} {
    margin-top: 20px;
  }
`
const MuiBox = styled(Box)``
const BoxStyle = styled(Box)`
  display: flex;
  ${Responsive.mobile} {
    display: block;
  }
`
const Wrapper = styled.div`
  height: 100%;
  .MuiButtonBase-root {
    font-family: inherit;
  }
`
//
const DropdownWrapper = styled.div`
  margin-block: 32px;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
  align-items: flex-end;
  border-radius: 8px;
  background-color: ${Colors.white};
  padding: 32px 48px;
  box-shadow: rgba(136, 136, 136, 0.067) 0px 0px 15px 3px;

  ${Responsive.mobile} {
    padding: 20px;
  }
`
const ModalItems = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 50px 30px;
  ${Responsive.mobile} {
    padding: 0px;
  }
`
const ModalText = styled.div`
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 18px;
  color: ${Colors.primaryBlack};
`
export default MyPolicies
